import React from 'react'

import { ErrorMessage } from '@/components/forms/ErrorMessage'

import { MODEL_DEPRECATED_MESSAGE } from './modelGating'

// The inline save-block notice shown when the selected model is deprecated. Kept as its own
// component so the form render bodies don't carry the conditional — that keeps their cognitive
// complexity in budget and keeps the wording identical across every surface.
export const ModelDeprecatedNotice = ({ show }) =>
  show ? <ErrorMessage content={MODEL_DEPRECATED_MESSAGE} /> : null
